module.exports = __webpack_public_path__ + "img/services-icon-6.7f309506.png";